export default __webpack_public_path__ + "static/media/19.25e6b8fc.png";